/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import Text from 'solis/react/primitive/text';


export default ({ mark = '·', children }) =>
(
  <Flex align = 'center' gap = '1'>
    <Text.Note>{mark}</Text.Note>
    <Text.Note>{children}</Text.Note>
  </Flex>
);
